import { View, Text, Pressable, ImageBackground, ScrollView } from 'react-native'
import React, { useLayoutEffect } from 'react'
import GlobalStyles from './../style';
import { useNavigation } from '@react-navigation/native';

const ListOfButtons = ({route}) => {
    const buttonsRaw = route.params.btn
    const name = route.params.name ? route.params.name : undefined;
    const navigation = useNavigation();

    useLayoutEffect(() => {
        navigation.setOptions({
            //headerShown: false,
            headerTitle: ""
        })
    }, []);

    let buttons = []
    for (let i = 0; i < buttonsRaw.length; i++) {
        if(buttonsRaw.length<3)buttonsRaw.push('')
        buttons[i] = <View style={GlobalStyles.buttonMargins}><Pressable style={GlobalStyles.buttonMain}
        onPress={() => navigation.navigate(buttonsRaw[i][1],buttonsRaw[i][2])}>
            <Text style={GlobalStyles.textForButtonMain}>{buttonsRaw[i][0]}</Text>
        </Pressable>
        </View>
    }

    return (
        <View style={{height:'100%'}}>
            <ImageBackground source={ require('./../img/background3.png') } resizeMode="cover" style={{flex:1}}>
                <View style={{ flex: 1, flexDirection: 'column' }}>
                    <View style={{ flex:1, justifyContent:'center' }}>
                        <View>
                            <Text style={GlobalStyles.textForTitleScreen}>{name}</Text>
                        </View>
                    </View>
                    <View style={{ flex: 2 }}>
                        <View style={{marginHorizontal:25}}>
                            <ScrollView>
                                { buttons.map((button, index) => <View key={index}>{button}</View>) }
                            </ScrollView>
                        </View>
                    </View>
                </View>
            </ImageBackground>
        </View>
    )
}

export default ListOfButtons